import { money } from "../lib/api";
import { ArrowSquareOut, Eye } from "@phosphor-icons/react";

const METHOD_LABELS = { cash: "Cash", tyro: "Tyro EFTPOS", card: "Card", card_manual: "Card", stripe: "Stripe", store_credit: "Store credit", other: "Other" };
const TONES = {
  paid: "text-emerald-700", due: "text-amber-700", over: "text-rose-700", none: "text-slate-500",
};

function Row({ label, value, strong, tone = "", testId }) {
  return (
    <div className="flex items-center justify-between gap-3 px-5 py-2" data-testid={testId}>
      <span className={`text-[13px] ${strong ? "font-semibold" : ""} ${tone || (strong ? "text-slate-900" : "text-slate-600")}`}>{label}</span>
      <span className={`font-mono tabular-nums text-[13px] ${strong ? "font-bold" : ""} ${tone || (strong ? "text-slate-900" : "text-slate-700")}`}>{value}</span>
    </div>
  );
}

export const isFullyRefunded = (total, refunded, closedFlag) => refunded > 0.005 && (!!closedFlag || refunded >= Number(total || 0) - 0.005);

export function ReceiptFooter({ label = "Total", total, payments = [], refunded = 0, balance = 0, overpaid = 0, fullyRefunded = false,
                                number, statusLabel, viewed, viewCount, onOpen, actions, testId, openTestId }) {
  const state = fullyRefunded ? "refunded" : overpaid > 0.005 ? "over" : balance > 0.005 ? "due" : payments.length || refunded ? "paid" : "none";
  return (
    <div className="rounded-2xl border border-[#E5E7EB] bg-white overflow-hidden" data-testid={testId}>
      <div className="py-1.5">
        <Row label={label} value={`$${money(total)}`} strong testId="ticket-total-band" />
        {payments.map((p, i) => (
          <Row key={i} label={`Paid · ${p.tyro ? "Tyro EFTPOS" : METHOD_LABELS[p.method] || p.method}`} value={`−$${money(p.amount)}`} testId={`receipt-payment-${i}`} />
        ))}
        {refunded > 0.005 && <Row label="Refunded" value={`+$${money(refunded)}`} testId="receipt-refunded" />}
      </div>
      <div className="mx-5 border-t border-dashed border-slate-300" />
      <div className="py-1.5">
        {state === "refunded" ? <Row label="Refunded in full" value="$0.00" strong tone={TONES.over} testId="receipt-refunded-full" />
          : state === "over" ? <Row label="Overpaid · refund due" value={`$${money(overpaid)}`} strong tone={TONES.over} testId="receipt-overpaid" />
          : state === "due" ? <Row label="Balance due" value={`$${money(balance)}`} strong tone={TONES.due} testId="receipt-balance" />
          : state === "paid" ? <Row label="Paid in full" value="$0.00" strong tone={TONES.paid} testId="receipt-paid" />
          : <Row label="Not paid yet" value={`$${money(total)}`} strong tone={TONES.none} testId="receipt-unpaid" />}
      </div>
      <div className="px-5 py-2.5 border-t border-[#F1F5F9] bg-[#FAFBFC] flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-[12px] text-slate-500 min-w-0">
          {number ? <span className="font-mono font-semibold text-slate-700">{number}</span> : <span>No invoice yet</span>}
          {statusLabel && <><span className="text-slate-300">·</span><span>{statusLabel}</span></>}
          {viewed && (
            <span className="inline-flex items-center gap-1 text-[#1E5FEB]" data-testid={`viewed-badge-${number}`}>
              <Eye size={12} weight="bold" /> Viewed{viewCount > 1 ? ` ${viewCount}×` : ""}
            </span>
          )}
        </div>
        <div className="flex items-center gap-3">
          {actions}
          {onOpen && (
            <button onClick={onOpen} data-testid={openTestId} className="h-8 px-3.5 rounded-lg border border-[#1E5FEB] bg-white hover:bg-[#EFF6FF] text-[#1E5FEB] text-[12px] font-bold inline-flex items-center gap-1.5 transition-colors">
              <ArrowSquareOut size={13} weight="bold" /> Open invoice
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
